// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"fe75b60e","162":"2c06a6b6","338":"ded7e8fb","339":"8453477f"}[chunkId] + ".chunk.css";
};